











































































import { Component, Prop, Vue } from 'vue-property-decorator';

import Loading from '@/components/Loading.vue';
import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { ApiService, curApiService } from '@/services/ApiService';
import { ApiClient, curApiClient } from '@/services/ApiClient';

@Component({
  components: {
    Loading,
    Error,
    SectionHeader,
    Success
  },
})
export default class CreateEnterprise extends Vue {

  @Prop({ default: () => [],  type: Array}) enrolProfileIdList!: string[];

  // our model
  error:string = '';
  success:string = '';

  // our model
  enterpriseId = "";
  dataStorage = true;
  dataDecoding = true;
  enrolId = 'default';
  subscriberId = 1100000000;
  supplierId = ''
  
  httpLoadingBusy = false;
  httpCreatingBusy = false;

  entIdList:string[] = [];

  // internal dependencies
  private apiService:ApiService = curApiService;
  private apiClient:ApiClient = curApiClient;
  
  async mounted() {

    this.httpLoadingBusy = true;

    let enterprisesReply = await this.apiService.getEnterprises({});

    this.httpLoadingBusy = false;
    
    if(enterprisesReply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(enterprisesReply.errorMsg)
      return this.error = `Unable to retrieve enterprise list: ${enterprisesReply.errorMsg}`;
    
    // we update the state
    this.entIdList = enterprisesReply.entList!.map(ent => ent.enterpriseId);
  }
  
  get canCreate():boolean {
    return !this.httpLoadingBusy && !this.httpCreatingBusy;
  }

  async doCreate() {

    this.httpCreatingBusy = true;
    this.error = '';

    let newEnterpriseReq = {
      enterpriseId: this.enterpriseId,
      dataDecoding: this.dataDecoding,
      dataStorage: this.dataStorage,
      nwServer: {
        actility: {
          subscriberId: this.subscriberId,
          supplierId: this.supplierId !== '' ? this.supplierId : undefined,
          enrolId: this.enrolId
        }
      }
    }

    const reply = await this.apiClient.createEnterprise(newEnterpriseReq);

    this.httpCreatingBusy = false;
    
    if(reply.errorMsg)
      return this.error = `unable to create enterprise: ${reply.errorMsg}`;

    this.setSuccess(`enterprise ${this.enterpriseId} created successfully`);
    
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 2000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
